// eslint-disable-next-line @typescript-eslint/no-empty-function
export default () => { };
//# sourceMappingURL=NOOPUtils.js.map